import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

export default new AclCreate({
  initial: 'guest',
  notfound: '/pages/not-authorized',
  router,
  acceptLocalRules: true,
  globalRules: {
    isGlobal: new AclRule('user')
      .or('admin')
      .or('operator')
      .or('manager')
      .or('system')
      .generate(),
    isPublic: new AclRule('user')
      .or('admin')
      .or('operator')
      .or('manager')
      .generate(),
    guest: new AclRule('guest').generate(),
    admin: new AclRule('admin').or('system').generate(),
    system: new AclRule('system').generate(),
    user: new AclRule('user').generate(),
    manager: new AclRule('manager').generate(),
    operator: new AclRule('operator').generate(),
    managerOrOperator: new AclRule('manager').or('operator').generate()
  },
  middleware: async acl => {
    let roles = 'guest'
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'))
    if (userInfo && userInfo.roles) roles = userInfo.roles
    acl.change(roles)
  }
})
